import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SpecialCharacterIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SpecialCharacter",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.25 27.37h-6.46c-.8.03-1.52-.48-1.75-1.24-.22-.74.07-1.54.72-1.96 4.03-2.67 5.13-8.1 2.47-12.13-2.67-4.03-8.1-5.13-12.13-2.47-4.03 2.67-5.13 8.1-2.47 12.13.65.98 1.49 1.82 2.47 2.47a1.742 1.742 0 0 1-1.03 3.2H3.75c-.97 0-1.75-.78-1.75-1.75s.78-1.75 1.75-1.75h2.19C2.08 18.31 3.46 10.68 9.02 6.82S22.21 4.34 26.07 9.9c2.92 4.2 2.92 9.77 0 13.97h2.19c.97 0 1.75.78 1.75 1.75s-.78 1.75-1.75 1.75Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M10.39 29.29H1a1.14 1.14 0 1 1 0-2.28h5.52c-3.1-2.68-4.97-6.62-4.97-10.83-.01-7.9 6.41-14.32 14.31-14.32s14.31 6.42 14.31 14.31c0 4.21-1.87 8.15-4.97 10.83h5.52a1.14 1.14 0 1 1 0 2.28h-9.39c-.54 0-1-.37-1.12-.9s.15-1.06.64-1.28a12.05 12.05 0 0 0 7.04-10.93c0-6.63-5.4-12.03-12.03-12.03S3.83 9.54 3.83 16.17c0 4.69 2.76 8.98 7.04 10.93.49.22.76.76.64 1.28s-.58.9-1.12.9Z"
      })
    })
  }));
};
SpecialCharacterIcon.displayName = 'SpecialCharacterIcon';